import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import SolutionFinder from "@/components/SolutionFinder";
import { SERVICES } from "@/lib/site";

export default function Solutions() {
  return (
    <>
      <Seo
        title="Solutions — Riverstone Partners"
        description="Explore Riverstone Partners' solution areas: marketing and website design, employee health and wellness, medical claims and billing, shipping and freight, and emerging opportunities."
        path="/solutions"
      />

      <section className="border-b border-charcoal/10 bg-sage/50 py-16 md:py-24">
        <div className="shell max-w-3xl">
          <p className="eyebrow text-forest">Solutions</p>
          <h1 className="mt-5 font-serif text-4xl font-light leading-[1.1] tracking-tight text-navy sm:text-5xl" data-testid="solutions-title">
            Practical solutions, matched to your priorities.
          </h1>
          <p className="mt-6 text-lg leading-relaxed text-charcoal/80">
            Riverstone Partners helps you explore five solution areas—each delivered by
            established specialists, each introduced only when it may fit your goals.
            Start with a conversation; there’s no obligation to go further.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="shell">
          <div className="space-y-6">
            {SERVICES.map((s, i) => (
              <Reveal key={s.slug} delay={0.05 * i}>
                <Link
                  to={`/solutions/${s.slug}`}
                  data-testid={`solutions-row-${s.slug}`}
                  className="group grid items-stretch gap-0 border border-charcoal/10 bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-lift md:grid-cols-[1fr_1.6fr]"
                >
                  <div className="overflow-hidden">
                    <img
                      src={s.image}
                      alt={s.imageAlt}
                      width="1200"
                      height="750"
                      loading={i < 2 ? "eager" : "lazy"}
                      className="h-56 w-full object-cover transition-transform duration-700 group-hover:scale-[1.03] md:h-full"
                    />
                  </div>
                  <div className="flex flex-col justify-center p-7 md:p-10">
                    <p className="eyebrow text-river">{s.provider}</p>
                    <h2 className="mt-3 font-serif text-2xl font-light tracking-tight text-navy sm:text-3xl">
                      {s.name}
                    </h2>
                    <p className="mt-3 max-w-2xl text-lg leading-relaxed text-charcoal/80">{s.short}</p>
                    <p className="mt-4 inline-flex min-h-[44px] items-center gap-3 text-sm font-semibold uppercase tracking-[0.1em] text-river">
                      <span className="h-px w-6 bg-river" aria-hidden="true" />
                      {s.benefit}
                    </p>
                    <span className="mt-5 inline-flex min-h-[44px] items-center gap-2 text-sm font-semibold uppercase tracking-[0.14em] text-forest">
                      Explore this solution
                      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <SolutionFinder />
    </>
  );
}
